import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './MapProperties.module.scss';
import Mapbox from "../../../../components/Mapbox/Mapbox.component";

class MapProperties extends React.Component {
  render() {
    const { properties } = this.props;
    return (
      <div className={`${style.map_container}`}>
        <Mapbox properties={properties} pickable={false} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MapProperties));
